import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const TICKET_USAGE_URL = `${API_URL}/gorgias/tickets/usage/`

export async function getTicketUsage(companyID: number) {
  return axios.get(TICKET_USAGE_URL + `${companyID}/`)
}
